import { useState } from "react";
import DashboardHeader from "../components/DashboardHeader"; 
import CursuriSection from "../components/CursuriSection";
import CartiSection from "../components/CartiSection";
import { Library, BookOpen, GraduationCap } from "lucide-react";

export default function BibliotecaDigitalaPage({ memberData }) {
  const [activeTab, setActiveTab] = useState("carti");

  return (
    <div className="dashboard-wrapper" style={{ overflowX: "hidden", minHeight: "100vh", backgroundColor: "#0b1120", paddingBottom: "40px" }}>
      <DashboardHeader user={memberData} />
      
      {/* Stiluri pentru taburile dark premium */}
      <style>{`
        .premium-tabs-container {
          display: inline-flex;
          gap: 12px;
          background: rgba(255, 255, 255, 0.02);
          padding: 8px;
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          margin-top: 24px;
          margin-bottom: 24px;
          overflow-x: auto;
        }
        .premium-tab-btn {
          background: transparent;
          color: #94a3b8;
          border: none;
          padding: 12px 24px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 0.95rem;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
          display: flex;
          alignItems: center;
          gap: 8px;
        }
        .premium-tab-btn:hover {
          color: #cbd5e1;
          background: rgba(255, 255, 255, 0.05);
        }
        .premium-tab-btn.active {
          background: #1e293b;
          color: #fbbf24;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.05);
        }
      `}</style>

      <div style={{ maxWidth: 1140, margin: "0 auto", padding: "0 16px" }}>
        <h3 style={{ color: "#f8fafc", fontWeight: 700, marginTop: "32px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "12px" }}>
          <Library color="#fbbf24" size={32} /> Biblioteca Digitală
        </h3>

        {/* Meniu Tab-uri */}
        <div className="premium-tabs-container">
          <button
            type="button"
            className={`premium-tab-btn ${activeTab === "carti" ? "active" : ""}`}
            onClick={() => setActiveTab("carti")}
          >
            <BookOpen size={18} /> Cărți și Documente
          </button>
          <button
            type="button"
            className={`premium-tab-btn ${activeTab === "cursuri" ? "active" : ""}`}
            onClick={() => setActiveTab("cursuri")}
          >
            <GraduationCap size={18} /> Cursuri Interactive
          </button>
        </div>

        {/* Conținut Tab */}
        <div className="mt-3">
          {activeTab === "carti" ? <CartiSection /> : <CursuriSection memberId={memberData?.id} memberName={`${memberData?.nume || ""} ${memberData?.prenume || ""}`.trim()} />}
        </div>
      </div>
    </div>
  );
}
